import React, { Component } from 'react';
import { setCookie, getCookie, monthTimeout } from '../../../../helpers/cookie';
import AuthInputs from '../../../auth/helpers/inputs';
// import AuthActionBtn from '../../../auth/helpers/actionBtn';
import errorHandler from '../../../auth/service/errors';
import prepareAuthNotes from '../../../auth/helpers/notes';
import AuthValidateData from '../../../auth/helpers/validateData';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: this.props.checkout.phone || '',
      password: '',
      errorPhone: false,
      errorPassword: false,
      loading: false,
      message: null,
    };
  }

  // Берем телефон из куков
  componentDidMount() {
    const phone = getCookie('PHONE');
    if (phone) this.setState({ phone });
  }

  getErrors = err => {
    const responseError = errorHandler(err);

    // Проверка наличия кода ошибки в списке ошибок
    if (typeof responseError === 'undefined') {
      const message =
        typeof err.message !== 'undefined'
          ? err.message
          : 'Попробуйте обновить страницу.';
      this.setState({ message, loading: false });
    } else {
      this.setState(responseError);
    }
  };

  changeState = vals => {
    this.setState({
      ...vals,
    });
  };

  confirm = e => {
    e.preventDefault();

    const { errorPhone } = this.state;

    this.setState({ loading: true });

    if (!errorPhone) {
      this.sendRequest('confirmUser');
    }
  };

  sendRequest() {
    const { route, onBackClick, updateUser } = this.props;
    const { phone, password } = this.state;

    const cleanPhone = phone
      ? phone.replace(/[/+()_-]*/g, '').replace(/\s/g, '')
      : '';

    const formData = new FormData();
    formData.append('phone', cleanPhone);
    formData.append('password', password);

    const url = route.loginbypass;

    const headers = {
      method: 'POST',
      body: formData,
      headers: {},
      credentials: 'include',
    };

    fetch(url, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          updateUser(json.data.user);
          setCookie('PHONE', cleanPhone, monthTimeout);
          this.setState({
            loading: false,
          });
          onBackClick();
        } else if (json.status === 'error') {
          this.getErrors(json.errors);
        }
      })
      .catch(() => {
        this.setState({
          message:
            'Попробуйте обновить страницу.',
        });
      });
  }

  prepareBtn() {
    const { loading, phone, password, errorPhone, errorPassword } = this.state;

    const btnClasses = ['btn', 'btn--accent']; // TODO color btn
    if (loading) btnClasses.push('btn--loading');

    let type = 'submit';

    if (
      !AuthValidateData({
        tab: 'auth',
        phone,
        password,
        errorPhone,
        errorPassword,
      })
    ) {
      type = 'button';
      btnClasses.push('btn--disable');
    }

    return (
      <button className={btnClasses.join(' ')} type={type}>
        Войти
      </button>
    );
  }

  render() {
    const { phone, password, errorPhone, errorPassword, message } = this.state;

    const { onBackClick } = this.props;

    const tab = 'auth';

    return (
      <div className="buy-checkout-side__container">
        {/* mobile version */}
        <div className="scheme-popup__top">
          <button
            className="scheme-popup__top-btn left"
            type="button"
            onClick={() => onBackClick()}
          >
            <svg
              className="icon--shev"
              width="10"
              height="15"
              viewBox="0 0 5 8"
            >
              <path d="M3.6 7.8c.2.1.4.2.6.2.4 0 .8-.4.8-.9 0-.2-.1-.4-.3-.6l-2.6-2.5 2.6-2.5c.2-.2.3-.4.3-.6 0-.5-.4-.9-.8-.9-.2 0-.4.1-.6.2l-3.3 3.1c-.3.3-.4.9 0 1.2l3.3 3.3z" />
            </svg>
          </button>
          <h4 className="heading heading--2">Вход в кабинет</h4>
        </div>

        {/* desktop version */}
        <button
          onClick={() => onBackClick()}
          className="buy-checkout-side__back"
          type="button"
        >
          <svg width="8" height="5">
            <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-shev-down"></use>
          </svg>
          Назад
        </button>
        <h4 className="buy-checkout-side__title">Вход в кабинет</h4>

        <form
          className="buy-checkout-side__inp-container"
          onSubmit={this.confirm}
        >
          <AuthInputs
            tab={tab}
            phone={phone}
            password={password}
            errorPhone={errorPhone}
            errorPassword={errorPassword}
            getCode={false}
            changeState={vals => this.changeState(vals)}
            isPopup
          />

          {prepareAuthNotes({ errorPassword, errorPhone, message })}

          {this.prepareBtn()}

          <a
            className="login-form__note link accent"
            href="/login"
            onClick={e => this.props.saveUserChoose(e)}
          >
            Забыли пароль?
          </a>
        </form>
      </div>
    );
  }
}

export default Login;
